<div class="tw-flex tw-items-stretch">
  @if (isMillisecond) {
    <input
      type="number"
      class="hmm-input tw-min-w-0 tw-flex-1 tw-rounded-e-none"
      placeholder="Milliseconds"
      [(ngModel)]="timeModel.milliseconds"
      (change)="onChange()"
      [formlyAttributes]="field"
    />
    <span
      class="tw-flex tw-items-center tw-border tw-border-s-0 tw-border-cloud tw-bg-cloud-4 tw-px-3 tw-text-sm"
      >ms</span
    >
  } @else {
    <input
      type="number"
      class="hmm-input tw-min-w-0 tw-flex-1 tw-rounded-e-none"
      placeholder="Minutes"
      [(ngModel)]="timeModel.minutes"
      (change)="onChange()"
      [formlyAttributes]="field"
    />
    <span
      class="tw-flex tw-items-center tw-border tw-border-s-0 tw-border-cloud tw-bg-cloud-4 tw-px-3 tw-text-sm"
      >min</span
    >
    <input
      type="number"
      class="hmm-input tw-min-w-0 tw-flex-1 tw-rounded-none tw-border-s-0"
      placeholder="Seconds"
      [(ngModel)]="timeModel.seconds"
      (change)="onChange()"
      [formlyAttributes]="field"
    />
    <span
      class="tw-flex tw-items-center tw-border tw-border-s-0 tw-border-cloud tw-bg-cloud-4 tw-px-3 tw-text-sm"
      >sec</span
    >
  }

  <button
    type="button"
    aria-label="Toggle milliseconds"
    class="tw-btn tw-rounded-s-none tw-border-s-0"
    (click)="isMillisecond = !isMillisecond"
  >
    @if (isMillisecond) {
      <i class="bi bi-clock-history"></i>
    } @else {
      <i class="bi bi-clock"></i>
    }
  </button>
</div>
